const $ = window.jQuery;

function __guardMethod__(obj, methodName, transform) {
	if (
		typeof obj !== "undefined" &&
		obj !== null &&
		typeof obj[methodName] === "function"
	) {
		return transform(obj, methodName);
	} else {
		return undefined;
	}
}

Ok.IncognitoModal = {
	init(params) {
		if (
			typeof incognito_controller === "undefined" ||
			incognito_controller === null
		) {
			return;
		}

		this.package = params.package;
		this.packageInfo = params.packageInfo;

		this.Dom = {
			modal: $("#incognito_promo"),
			document: $(document),
		};
		this.Dom.radios = this.Dom.modal.find("input[type=radio]");
		this.Dom.button = this.Dom.modal.find(".flatbutton.purchase");
		this.Dom.cancel = this.Dom.modal.find(".cancel");
		this.Dom.close = this.Dom.modal.find(".close");
		this.Dom.form = this.Dom.modal.find(".incognito-modal-form");

		this.Data = {
			hasPackages: this.Dom.modal.hasClass("incognito-modal-packages"),
			planid: null,
		};

		this.Data.modalType = this.Data.hasPackages ? "packages" : "single";

		if (params.open) {
			this.open();
		}

		if (this.Data.hasPackages && this.Dom.form.length) {
			this.Data.okform = new OkForm(this.Dom.form.get(0));
			const firstradio = this.Dom.radios.first();
			firstradio.prop("checked", true);
			this.Data.okform.setInputLabelState(firstradio.attr("id"));
			this.update({ skipAnalytics: true });
		} else {
			this.Data.planid = params.planid;
		}

		this.listen();

		if (this.Data.hasPackages) {
			IncognitoCarousel.init();
		}

		// if incognito is in the hash, open that right up
		if (this.hasHash()) {
			return this.open();
		}
	},

	listen() {
		let target;
		if (this.Data.hasPackages) {
			this.Dom.radios.on("change", this.update.bind(this));
		}

		this.Dom.button.on("click tap", this.purchase.bind(this));
		this.Dom.cancel.on("click tap", this.close.bind(this));
		this.Dom.close.on("click tap", this.close.bind(this));
		this.Dom.modal.on("modalclose", this.onModalClose.bind(this));

		// upgrade links around the site
		this.Dom.document

			// ordinary upgrade ads
			.on("click tap", ".upgrade_ad.incognito a", (ev) => {
				ev.preventDefault();
				target = $(ev.currentTarget);
				this.storeCf(target);

				this.open();
			})

			// ditto, masthead ads
			.on("click tap", ".incognito-masthead-learnmore", (ev) => {
				ev.preventDefault();
				incognito_controller.add_cf("incognito_masthead");
				ClientStats.update({
					statname:
						"desktop - incognito - modal - opened - promo:incognito_masthead",
				});

				this.open();
			})

			// settings aside
			.on("click tap", ".incognito-upgrade-link .buttons .flatbutton", (ev) => {
				ev.preventDefault();
				target = $(ev.currentTarget);
				this.storeCf(target);

				this.open();
			});
	},

	storeCf(el) {
		// process CF codes
		const cf = el.data("cf").split(",");

		cf.map((code) => {
			incognito_controller.add_cf(code);
			ClientStats.update({
				statname: `desktop - incognito - modal - opened - promo:${cf}`,
			});
			return true;
		});
	},

	hasHash() {
		const isInHash = window.location.hash.indexOf("showIncognito") !== -1;
		const isInQuery = window.location.search.indexOf("showIncognito") !== -1;
		return isInHash || isInQuery;
	},

	throwSelectedPlanAnalytics() {
		const pkg = this.packageInfo[this.Data.planid];

		OkAnalytics.logUIEvent(
			OkAnalytics.eventNames.purchasesSelectedPlanOnIncognitoUpsell,
			{
				data: {
					"Plan duration in months": pkg.months,
					"Gross proceeds in local currency": pkg.price / 100,
				},
			},
		);
	},

	update(param) {
		if (param == null) {
			param = {};
		}

		const { skipAnalytics } = param;
		this.Data.planid = this.Dom.radios.filter("input:checked").val();

		// add a class to the selected label
		this.Dom.form
			.find(".incognito-plan-selected")
			.removeClass("incognito-plan-selected");
		$(`#incognito-plan-label-${this.Data.planid}`).addClass("incognito-plan-selected");

		if (!skipAnalytics) {
			this.throwSelectedPlanAnalytics();
		}
	},

	open(ev) {
		__guardMethod__(ev, "preventDefault", (o) => o.preventDefault());
		Modal.open(this.Dom.modal.attr("id"));
		this.Dom.radios.first().prop("checked", true);
		this.throwSelectedPlanAnalytics();

		const statnames = [
			"desktop - incognito - modal - opened",
			`desktop - incognito - modal - type:${this.Data.modalType} - opened`,
		];

		ClientStats.update({ statnames });
	},

	purchase() {
		const pkg = this.packageInfo[this.Data.planid];

		OkAnalytics.logUIEvent(
			OkAnalytics.eventNames.purchasesSelectedSubscribeOnIncognitoUpsell,
			{
				data: {
					"Plan duration in months": pkg.months,
					"Gross proceeds in local currency": pkg.price / 100,
				},
			},
		);

		this.close();
		incognito_controller.set_param("planid", this.Data.planid);
		incognito_controller.open();
	},

	succeed() {
		// if we're on the incognito page, and there's an alt dest, use that
		let url;
		if (jQuery("#incognito-destination").length) {
			url = jQuery("#incognito-destination").val();
			ClientStats.update("desktop - signup - incognito - purchases");
		} else {
			// redirect to the success page in a hot sec, sans hash
			url = window.location.href;
			url = url.replace(window.location.hash, "");
		}

		setTimeout(() => {
			window.location = url;
		}, 1000);
	},

	close(ev) {
		__guardMethod__(ev, "preventDefault", (o) => o.preventDefault());
		Modal.close(this.Dom.modal.attr("id"));
	},

	onModalClose() {
		IncognitoCarousel.close();

		if (typeof masthead_ad_incognito_masthead !== "undefined") {
			masthead_ad_incognito_masthead.close();

			AjaxSookie.update(
				"incognito_masthead_closed",
				1,
				86400,
				"b872f436dcbb7ea670f0d9ae2022816269fbef9d",
			);
		}

		if (this.hasHash() && window.location.hash !== "") {
			window.location.hash = "";
		}

		const statnames = [
			"desktop - incognito - modal - canceled",
			`desktop - incognito - modal - type:${this.Data.modalType} - canceled`,
		];

		ClientStats.update({ statnames });
	},
};



// WEBPACK FOOTER //
// ./src/legacy/incognito/modal.js